export default {
  "content": "<path fill=\"#3F4450\" fill-rule=\"evenodd\" d=\"M12 13.124a6.5 6.5 0 10-8 0v-.874a2.4 2.4 0 01.586-1.591A1.895 1.895 0 016 10h4c.53 0 1.04.237 1.414.659A2.4 2.4 0 0112 12.25v.874zM8 16A8 8 0 108 0a8 8 0 000 16zm0-7a2.75 2.75 0 100-5.5A2.75 2.75 0 008 9z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none"
  }
};